import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL
const API_KEY = process.env.VUE_APP_API_KEY

export default class MerchantService {
  // eslint-disable-next-line class-methods-use-this
  async getChildren() {
    try {
      const { data } = await axios.get(`${BASE_URL}user/register`, {
        headers: {
          'Api-key': API_KEY,
        },
      })
      return data
    } catch (err) {
      return err.response.data
    }
  }
}
